module.exports = __webpack_public_path__ + "static/media/singleUser.64c56207.svg";